import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const MostUsedWrapper = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  grid-row-gap: ${pxToRem('16px')};
`;
export const MostUsedHeader = styled.div`
  display: grid;
  grid-template-columns: 30px 1fr 0.5fr;
`;
export const MostUsedTitle = styled.div`
  color: ${props => props.theme.colors.grayText};
  &.kwh {
    padding-left: ${pxToRem('15px')};
  }
`;
export const MostUsedContent = styled.div`
  margin: 0 -${pxToRem('24px')};

  > div:nth-child(even) {
    background-color: #f4f4f4;
    border-radius: ${pxToRem('8px')};
  }
`;
export const MostUsedItem = styled.div`
  display: grid;
  grid-template-columns: 30px 1fr 0.5fr;
  padding-left: ${pxToRem('24px')};
  height: ${pxToRem('40px')};
  align-content: space-around;
`;
export const Ranking = styled.div`
  > span:first-of-type {
    margin-right: ${pxToRem('8px')};
  }
`;
export const Name = styled.div`
  text-decoration: underline;
  cursor: pointer;
`;
export const Energy = styled.div``;
